import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WebcallbackService } from '../../services/webcallback.service';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-webcallback',
  templateUrl: './webcallback.component.html',
  styleUrls: ['./webcallback.component.scss']
})
export class WebcallbackComponent implements OnInit {

  formGroup: FormGroup;

  constructor(
    private webcallbackService: WebcallbackService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      numTel1: ['', Validators.required],
      numTel2: ['', Validators.required],
      numTel3: ['', Validators.required],
      numTel4: ['', Validators.required],
      numTel5: ['', Validators.required]
    });
  }

  submit(): void {
    let numTel = '';

    for (const field in this.formGroup.controls) {
      numTel = (numTel ? `${numTel} ` : numTel) + this.formGroup.get(field)?.value;
    }
    this.webcallbackService.demanderRappel(numTel).subscribe(
      response => {
        const dialogRef = this.dialog.open(PopUpSuccessDialog, { disableClose: true });
        console.log("ENVOYE : ", response)
      },
      error => console.log("ERROR ; ", error)
    )
  }
}

@Component({
  selector: 'popup-success',
  templateUrl: 'popup-success.html',
  styleUrls: ['./webcallback.component.scss']
})
export class PopUpSuccessDialog {
  constructor(
    public dialogRef: MatDialogRef<PopUpSuccessDialog>,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}